import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useZendeskChatIntegrationAutoSetupMutation } from 'src/services';
import { useNotification } from 'src/hooks/useNotification';
import { useLoader } from 'src/provider/LoaderProvider';
import { IntegrationZendeskChatAutoSetup } from 'src/components/Integrations/IntegrationAutoSetupPopup/IntegrationZendeskChatAutoSetup/IntegrationZendeskChatAutoSetup';
import { useAppSelector } from 'src/store';

export const ZendeskChatStep4 = ({
  onClose = (_v?: any) => {},
  onClick = (_v?: any) => {},
}: {
  onClose?: (v?: any) => void;
  onClick?: (v?: any) => void;
}) => {
  const { id } = useParams();
  const notification = useNotification();
  const loader = useLoader();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [
    setZendeskChatAutoSetup,
    { isSuccess: isSetZendeskChatAutoSetup, isLoading: isLoadingSetZendeskChatAutoSetup },
  ] = useZendeskChatIntegrationAutoSetupMutation();

  useEffect(() => {
    if (isSetZendeskChatAutoSetup) {
      notification.success('Integration Updated.');
      onClose(true);
    }
  }, [isSetZendeskChatAutoSetup]);

  useEffect(() => {
    if (isLoadingSetZendeskChatAutoSetup) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingSetZendeskChatAutoSetup]);

  const submitChat = async (formData) => {
    setZendeskChatAutoSetup({
      projectId: id,
      integrationId: formData.integrationId,
      body: formData,
    });
  };

  return (
    <IntegrationZendeskChatAutoSetup integration={selectedIntegration} onSubmit={submitChat} />
  );
};
